(() => {
  const loader = document.getElementById('ws-posthog-loader');
  const contextElement = document.getElementById('ws-posthog-context');
  if (!loader || !contextElement || loader.dataset.wsPosthogBound) return;
  loader.dataset.wsPosthogBound = 'true';
  const context = JSON.parse(contextElement.textContent);
  const token = 'phc_BZaRnUrh7RGhxgcMaRoCXsjX2fp3ykuEYfhrEqLPBDaV';
  const blocked = [
    '.ph-no-capture', '[data-ph-no-capture]',
    '.tee-mockup-zoomable', '.tee-mockup', '.teeinblue-wrapper',
    '.tee-artworks-wrapper', '.tee-preview-design', '.tee-modal',
    '.tee-field--upload', '.tee-field--upload-image',
    '#tee-artwork-form img', '#CartPopup img',
    '.upcart-item-properties', '.upcart-item-property',
    '.cart-item__properties', '.line-item__properties',
    '[data-customization-id]', 'canvas'
  ].join(', ');
  let requested = false;
  let ready = false;
  let active = false;
  let loadAttempts = 0;
  let loadingPrivacy = false;

  function status(value) {
    loader.dataset.wsPosthogState = value;
  }

  function permitted() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true &&
        navigator.doNotTrack !== '1' && navigator.globalPrivacyControl !== true;
    } catch {
      return false;
    }
  }

  function cleanUrl(value) {
    if (typeof value !== 'string' || !value) return value;
    if (value.startsWith('$')) return value;
    try {
      const url = new URL(value, location.origin);
      url.username = '';
      url.password = '';
      url.hash = '';
      const safe = new URLSearchParams();
      for (const key of ['variant', 'recipient', 'kind', 'budget']) {
        const parameter = url.searchParams.get(key);
        if (parameter && /^[a-z0-9_-]{1,60}$/i.test(parameter)) safe.set(key, parameter);
      }
      url.search = safe.toString();
      if (/\/(account|checkouts?|orders)(\/|$)|\/cart\/c\//i.test(url.pathname)) {
        url.pathname = '/[private]';
        url.search = '';
      }
      return url.toString();
    } catch {
      return '';
    }
  }

  function beforeSend(event) {
    if (!permitted()) return null;
    if (event.event === '$snapshot') return event;
    const properties = event.properties || {};
    for (const key of Object.keys(properties)) {
      if (/email|phone|first_name|last_name|address|\$set|\$initial_person_info|search_term/i.test(key)) {
        delete properties[key];
      } else if (/url|referrer|href/i.test(key) && typeof properties[key] === 'string') {
        properties[key] = cleanUrl(properties[key]);
      }
    }
    event.properties = properties;
    return event;
  }

  function syncConsent() {
    if (!permitted()) {
      if (ready && active) {
        active = false;
        window.posthog.opt_out_capturing({ clear_persistence: true });
        window.posthog.stopSessionRecording();
      }
      status('waiting-for-consent');
      return;
    }
    if (!requested) {
      requested = true;
      status('loading');
      loadPostHog();
      return;
    }
    if (ready && !active) {
      active = true;
      window.posthog.register({
        ws_store: 'weinspirits',
        ws_page_type: context.page_type,
        ws_locale: context.locale,
        ws_market_country: context.country,
        ws_currency: context.currency,
        ws_theme_id: context.theme_id,
        ws_theme_role: context.theme_role,
        ws_internal_preview: context.theme_role !== 'main'
      });
      window.posthog.opt_in_capturing();
      window.posthog.capture('$pageview');
      window.posthog.startSessionRecording();
      status('ready');
    }
  }

  function loadPostHog() {
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null;status('load-error')},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroups onFeatureFlags addFeatureFlagsHandler onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep startSessionRecording stopSessionRecording".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    window.posthog.init(token, {
      api_host: 'https://eu.i.posthog.com',
      ui_host: 'https://eu.posthog.com',
      defaults: '2026-08-30',
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      opt_out_capturing_persistence_type: 'cookie',
      person_profiles: 'never',
      capture_pageview: false,
      capture_pageleave: true,
      capture_heatmaps: true,
      capture_exceptions: false,
      capture_performance: false,
      disable_surveys: true,
      disable_session_recording: false,
      enable_recording_console_log: false,
      secure_cookie: true,
      mask_all_text: true,
      mask_all_element_attributes: true,
      autocapture: {
        dom_event_allowlist: ['click', 'change', 'submit'],
        element_allowlist: ['a', 'button', 'select', 'form', 'label'],
        css_selector_ignorelist: [
          '.ph-no-autocapture', '[data-ph-no-autocapture]',
          '#teeFormInputs', '.upcart-item-properties',
          '.tee-preview-design', '[data-customization-id]'
        ],
        capture_copied_text: false
      },
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '#teeFormInputs, .upcart-item-properties, .upcart-item-property, .cart-item__properties, .line-item__properties, [data-personalization], .ph-mask',
        blockSelector: blocked,
        recordBody: false,
        recordHeaders: false,
        streamNetworkBody: false,
        captureJsonLd: false,
        recordCrossOriginIframes: false,
        recordCanvas: false,
        maskCapturedNetworkRequestFn: request => ({
          name: cleanUrl(request.name),
          entryType: request.entryType,
          startTime: request.startTime,
          duration: request.duration,
          endTime: request.endTime,
          timeOrigin: request.timeOrigin,
          timestamp: request.timestamp,
          isInitial: request.isInitial
        })
      },
      before_send: beforeSend,
      loaded: () => {
        ready = true;
        syncConsent();
      }
    });
  }

  function connectPrivacy() {
    if (window.Shopify?.customerPrivacy) {
      syncConsent();
      return;
    }
    if (!loadingPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      loadingPrivacy = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        loadingPrivacy = false;
        if (!error) syncConsent();
        else status('privacy-unavailable');
      });
      return;
    }
    if (loadAttempts++ < 40) setTimeout(connectPrivacy, 250);
    else status('privacy-unavailable');
  }

  status('waiting-for-consent');
  document.addEventListener('visitorConsentCollected', syncConsent);
  window.addEventListener('pageshow', connectPrivacy);
  connectPrivacy();
})();

